const HeroBanner = () => {
  return <section className="section-0 d-flex align-items-end" />;
};
export default HeroBanner;
